const ChakraLib = {
  isTargetChakraSwitch: (target: EventTarget) =>
    target instanceof HTMLElement
    && Array.from(target.classList).some(className => className.includes('chakra-switch')),
}

export default ChakraLib
